// Stock photography used inside the illustrative phone screens.
export const photos = {
    surf: '/images/surf.jpg',
    neonCity: '/images/neon-city.jpg',
    sportsCar: '/images/sports-car.jpg',
    breakdance: '/images/breakdance.jpg',
    parkour: '/images/parkour.jpg',
    concert: '/images/concert.jpg',
    eagle: '/images/eagle.jpg',
    waterfall: '/images/waterfall.jpg',
    dancer: '/images/dancer.jpg'
} as const

// One shared `sizes` value so every tile of the same photo reuses a single download.
export const TILE_SIZES = '(min-width: 1024px) 560px, 80vw'

export const TEAL_TONE = 'sepia(1) hue-rotate(160deg) saturate(2.4) brightness(0.92)'
export const BLUE_TONE = 'sepia(1) hue-rotate(178deg) saturate(2.6) brightness(0.88) contrast(1.08)'
export const VIOLET_TONE = 'sepia(1) hue-rotate(215deg) saturate(2.8) brightness(0.95)'
